import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";

if (typeof window !== "undefined") {
	(window as unknown as { __HEDGEFAM_BUILD__?: string }).__HEDGEFAM_BUILD__ =
		"2026-05-14T21:16";
}

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root element missing from index.html");

createRoot(rootEl).render(
	<StrictMode>
		<App />
	</StrictMode>,
);
